export const CHECK_CONTACT_DUPLICATE_ENDPOINT = '/clientteling/check-dupplicate';
